var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sidebar-item',{key:2,staticClass:"text-white",attrs:{"menu":true,"link":{
    name: _vm.d.$t('Settings'),
    icon: 'circle',
  }}},[(_vm.d.hasPermission('settings_manage'))?_c('sidebar-item',{key:'2-1',staticClass:"text-white",attrs:{"link":{
      name: _vm.d.$t('System Configuration') || 'System Configuration',
      icon: 'cog',
      path: `/settings`,
    }}}):_vm._e(),_c('sidebar-item',{key:'user-menu-editor',staticClass:"text-white",attrs:{"link":{
      name: _vm.d.$t('userMenu.title'),
      icon: 'bars',
      path: `/gotrading/user-menu`,
    }}}),(_vm.d.hasPermission('model-definitions.view'))?_c('sidebar-item',{key:8,staticClass:"text-white",attrs:{"link":{
      name: 'Model Mapping',
      icon: 'retweet',
      path: `/gotrading/model-reference-mapping`,
    }}}):_vm._e(),(_vm.d.hasPermission('model-definitions.view'))?_c('sidebar-item',{key:22,staticClass:"text-white",attrs:{"link":{
      name: 'Model Definitions',
      icon: 'sitemap',
      path: `/model-definitions`,
    }}}):_vm._e(),(_vm.d.isAdminRole)?_c('sidebar-item',{key:'hook-automations',staticClass:"text-white",attrs:{"link":{
      name: 'Hook automations',
      icon: 'bolt',
      path: `/hook-automations`,
    }}}):_vm._e(),(_vm.d.hasPermission('views.view'))?_c('sidebar-item',{key:3,staticClass:"text-white",attrs:{"link":{
      name: 'Views',
      icon: 'eye',
      path: `/views`,
    }}}):_vm._e(),(_vm.d.hasPermission('roles.view'))?_c('sidebar-item',{key:4,staticClass:"text-white",attrs:{"link":{
      name: 'Roles',
      icon: 'user',
      path: `/roles`,
    }}}):_vm._e(),(_vm.d.canAccessUsersSettings())?_c('sidebar-item',{key:5,staticClass:"text-white",attrs:{"link":{
      name: _vm.d.$t('Users'),
      icon: 'users',
      path: `/users`,
    }}}):_vm._e(),(_vm.d.hasPermission('lists.view'))?_c('sidebar-item',{key:6,staticClass:"text-white",attrs:{"link":{
      name: _vm.d.$t('Lists'),
      icon: 'list',
      path: `/lists`,
    }}}):_vm._e(),(_vm.d.hasPermission('views.view'))?_c('sidebar-item',{key:63,staticClass:"text-white",attrs:{"link":{
      name: 'Links',
      icon: 'link',
      path: `/gotrading/admin-links`,
    }}}):_vm._e(),(_vm.d.hasPermission('settings_manage') && _vm.d.isAdminRole)?_c('sidebar-item',{key:25,staticClass:"text-white",attrs:{"link":{
      name: 'Módulos del Sistema',
      icon: 'box',
      path: `/modules`,
    }}}):_vm._e(),(_vm.d.hasPermission('settings_manage'))?_c('sidebar-item',{key:24,staticClass:"text-white",attrs:{"link":{
      name: 'Relaciones',
      icon: 'link',
      path: `/relationships`,
    }}}):_vm._e(),(_vm.d.hasPermission('settings_manage'))?_c('sidebar-item',{key:23,staticClass:"text-white",attrs:{"link":{
      name: 'Prompts IA',
      icon: 'robot',
      path: `/gotrading/prompt-settings`,
    }}}):_vm._e(),(_vm.d.isAdminRole)?_c('sidebar-item',{key:26,staticClass:"text-white",attrs:{"link":{
      name: _vm.d.$t('Orphans') || 'Orphans',
      icon: 'unlink',
      path: `/settings/orphans`,
    }}}):_vm._e(),(_vm.d.isAdminRole)?_c('sidebar-item',{key:27,staticClass:"text-white",attrs:{"link":{
      name: _vm.d.$t('refIntegrityAdmin.menu'),
      icon: 'database',
      path: `/admin/ref-integrity`,
    }}}):_vm._e(),(_vm.d.isAdminRole)?_c('sidebar-item',{key:28,staticClass:"text-white",attrs:{"link":{
      name: _vm.d.$t('migrations.menu'),
      icon: 'code-branch',
      path: `/settings/migrations`,
    }}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }